import React, { useState } from 'react'
import PropTypes from 'prop-types'

const Input = ({
  type,
  label,
  placeholder,
  defaultValue,
  value,
  onChange,
  error,
  focus,
  onKeyUp,
  maxLength,
  onFocus,
  onBlur,
  disabled,
  suffix,
  className,
  icon,
}) => {
  const [isFocused, setIsFocused] = useState(false)

  const handleFocus = () => {
    setIsFocused(true)
    if (onFocus) onFocus()
  }
  const handleBlur = () => {
    setIsFocused(false)
    if (onBlur) onBlur()
  }

  return (
    <div className={`input-wrapper${error ? ' input-wrapper--error' : ''}${className ? ` ${className}` : ''}${icon ? ' input-wrapper--has-icon' : ''}`}>
      <label>
        { label && <span>{ label }</span> }
        <div className={`input-wrapper--control${isFocused ? ' input-wrapper--control-focused' : ''}`}>
          {
            icon ?
            <div className='input-wrapper--control-icon'>{ icon }</div>
            :
            <></>
          }
          <div className='input-wrapper--input'>
            <input
              autoFocus={focus}
              type={type}
              placeholder={placeholder}
              onChange={onChange}
              value={value}
              defaultValue={defaultValue}
              onKeyUp={onKeyUp}
              maxLength={maxLength}
              disabled={disabled}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          </div>
          { suffix &&
            <span className='input-wrapper--suffix'>
              { suffix }
            </span>
          }
        </div>
      </label>
      { error &&
        <div className="input-error">{ error }</div>
      }
    </div>
  )
}

Input.propTypes = {
    type: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    defaultValue: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    error: PropTypes.string,
    focus: PropTypes.func,
    onKeyUp: PropTypes.func,
    maxLength: PropTypes.number,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    disabled: PropTypes.bool,
    suffix: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.object,
}

export default Input